import { ApplicationState } from '@app/store'
import {
  actionCreators as globalActionCreators,
  IGlobalConfigurationState,
  IGlobalPlacesState,
  selectConfiguration,
  selectPlaces,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import AddressEditor from '../components/AddressEditor'

export default connect(
  (state: ApplicationState) =>
    createStructuredSelector<
      ApplicationState,
      IGlobalConfigurationState & IGlobalPlacesState
    >({
      configuration: selectConfiguration(),
      places: selectPlaces(),
    }),
  globalActionCreators,
)(AddressEditor)
